import React, { Ref } from "react";
import classnames from "classnames";
import { Icon } from "@alm/flow-ds/components";

export interface Props {
	className?: string;
	children: React.ReactNode;
	index: number;
	onClick: () => void;
	active: boolean;
	selected: boolean;
	forwardedRef: Ref<HTMLDivElement>;
	name: string;
	initFocus: boolean;
	onMouseDown?: () => void;
	focus: boolean;
}

export default function KeyboardNavigableItem({
	className,
	children,
	onClick,
	index,
	active,
	selected,
	forwardedRef,
	name,
	initFocus,
	onMouseDown,
	focus,
}: Props) {
	return (
		<div
			ref={active ? forwardedRef : null}
			role="option"
			aria-selected={selected}
			className={classnames(
				"list-group-item",
				className,
				active && initFocus && focus ? "active" : "",
				selected ? "selected" : ""
			)}
			onMouseDown={onMouseDown}
			onClick={onClick}
			id={`${name}-list__item__${index}`}>
			<span className="list-group-item__selected-container">
				{selected && <Icon weight="r" type="check" />}
			</span>
			<div>{children}</div>
		</div>
	);
}
